/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'NO_IMPACT_TO_WORKERS_WORKERS_RECEIVE_THEIR_REGULAR_PAY_AND_COME',
              'WORKERS_MUST_STAY_AT_HOME_AND_ARE_REQUIRED_TO_USE_VACATION_TIME',
              'WORKER_S_HOURS_ARE_REDUCED',
              'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LEGAL_MINIMUM_WAGE',
              'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LESS_THAN_LEGAL_MINIMUM_',
              'WORKERS_MUST_STAY_AT_HOME_AND_ARE_NOT_PAID',
              'OTHER_ACTION_IMPACTING_WORKERS',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    when_productionvolume_is_lower_than_expected_how_are_wrkrs_impa: valueSchema,
  },
}
